import { render, staticRenderFns } from "./visual-type-accordion.vue?vue&type=template&id=72f02497&"
import script from "./visual-type-accordion.vue?vue&type=script&lang=js&"
export * from "./visual-type-accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports